module.exports = __webpack_public_path__ + "img/differential-calculus.ae8d74f1.png";